import { useMemo } from 'react';
import { useCommonPublicAPI as useCoreCommonPublicApi } from 'js/hooks/usePublicAPI/hooks/useCommonPublicAPI';
import { getStylesheet } from 'js/utils/scripts.util';

export const useCommonPublicAPI = () => {
    const corePublicAPIMethods = useCoreCommonPublicApi();

    return useMemo(() => ({
        ...corePublicAPIMethods,
        /**
         * Load script.
         * @memberOf Playtech.API.common
         * @function
         * @param url {String} URL to CSS file to load.
         * @example
         * Playtech.API.common.getStylesheet('https://www.example.com/example.css');
         */
        getStylesheet
    }), [corePublicAPIMethods]);
};
